
import { defineComponent, reactive } from "vue";
import ReqeustResponse from "@/components/common/Request/RequestResponse.vue";
import { RequestKindTypes } from "@/models/request";

export default defineComponent({
  name: "Online Care Response",
  props: {
    id: { type: String, required: true },
  },
  setup(props) {
    const state = reactive({
      id: props.id,
    });

    return {
      state,
      RequestKindTypes,
    };
  },
  components: {
    ReqeustResponse,
  },
});
